import Layout from '@/layout/index.vue'
import { Route } from 'vue-router'

export const configureMap = {
  path: '/configure',
  component: Layout,
  meta: { title: '设置', code: 527556 },
  children: [
    {
      path: 'parentSync',
      component: () => import('@/views/configure/parentSync/index.vue'),
      meta: { title: '家长同步', drop: true, code: 794889 },
      children: [
        {
          path: 'monthReport',
          component: () =>
            import('@/views/configure/parentSync/monthReport/index.vue'),
          meta: { title: '月评报告', code: 837737 }
        }
      ]
    },
    {
      path: 'healthSetting',
      component: () =>
        import(
          /* webpackChunkName: "healthSetting" */ '@/views/configure/hardware/index.vue'
        ),
      meta: { title: '硬件配置', drop: true, code: 602806 },
      children: [
        {
          path: 'equip',
          meta: { title: '评估一体化', code: 873883 },
          component: () =>
            import('@/views/configure/hardware/equip/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import(
                  '@/views/configure/hardware/equip/list.vue'
                ),
              meta: { title: '设备列表', keepAlive: true }
            },
            {
              path: 'add',
              component: () =>
                import(
                  '@/views/configure/hardware/equip/add.vue'
                ),
              meta: { title: '添加设备' }
            },
            {
              path: 'edit',
              component: () =>
                import(
                  '@/views/configure/hardware/equip/add.vue'
                ),
              meta: { title: '修改设备' }
            }
          ]
        },
        {
          path: 'drink',
          component: () =>
            import('@/views/configure/hardware/drink/index.vue'),
          meta: { title: '饮水方案', code: 728245 },
          children: [
            {
              path: 'list',
              component: () =>
                import('@/views/configure/hardware/drink/list.vue'),
              meta: { title: '方案列表', code: '' }
            },
            // 饮水方案
            {
              path: 'scheme/:op/:id/:classId/:campusId',
              name: 'DrinkScheme',
              meta: { title: '方案' },
              component: () =>
                import('@/views/configure/hardware/drink/scheme/index.vue'),
              beforeEnter(to: Route, from: Route, next: Function) {
                const params = to.params
                if (params.id && Number(params.id) > 0) {
                  if (params.op === 'view') to.meta.title = '查看方案'
                  else to.meta.title = '编辑方案'
                } else {
                  to.meta.title = '添加方案'
                }
                next()
              }
            }
          ]
        },
        {
          path: 'machine',
          component: () =>
            import('@/views/configure/hardware/machine/index.vue'),
          meta: { title: '晨检机', code: 856204 }
        },
        {
          path: 'morningCheckCard',
          component: () =>
            import('@/views/configure/hardware/device/morningCheckCard.vue'),
          meta: { title: '晨检卡', code: 659372 }
        },
        {
          path: 'wristband',
          component: () =>
            import('@/views/configure/hardware/device/wristband.vue'),
          meta: { title: '手环', code: 663111 }
        }
      ]
    }
  ]
}
